import { render, staticRenderFns } from "./CategoryFrequentlyAskedQuestions.vue?vue&type=template&id=4769957a&scoped=true&"
import script from "./CategoryFrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
export * from "./CategoryFrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFrequentlyAskedQuestions.vue?vue&type=style&index=0&id=4769957a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4769957a",
  null
  
)

export default component.exports